// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoSnowflake } from '../../../assets/images/Logos/logo-snowflake.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoSnowflakeIcon = /* @__PURE__ */ withLogoClass(LogoSnowflake);
